export const PreAlertas =[
    {
      Header: "No. de Tracking",
      accessor: "guia"
    },
    {
        Header: "Comentario",
        accessor: "comentario"
      },
    {
      Header: "Tienda de Compra",
      accessor: "tienda"
    },
    {
       Header: "Valor del Producto",
       accessor: "valor"
    },
    {
       Header: "Ver Factura",
       accessor: "url"
    }
  ];


  export const PreAlertaInicial={
    guia:"",
    comentario:"",
    tienda:"",
    valor:"",
    url:"-"
  }